import React from 'react'

import { navigate } from 'gatsby'

import { CloseButtonV2 } from '../General'

const MobileExitArticleButton = () => {
	const goToDirectory = () => {
		navigate('/')
	}

	return (
		<>
			<div>
				<CloseButtonV2
					inNavBar
					onClick={() => {
						goToDirectory()
					}}
					transparent
				/>
			</div>

			<style jsx>{`
				div {
					display: none;
				}

				@media only screen and (max-width: 768px), (pointer: coarse) {
					div {
						height: 100%;
						display: flex;
						align-items: center;
						width: 40px;
					}
				}
			`}</style>
		</>
	)
}

export default MobileExitArticleButton
